// extracted by mini-css-extract-plugin
export default {"dates":"dates_dates__JZxix"};